import { Injectable } from "@angular/core";
// services
import { LoginService } from "./login.service";
// shared
import { Cached, getCached } from "../decorators/cached.decorator";

// API
import { Status, UserRight } from "../WebApiClient";

@Injectable({
    providedIn: "root",
})
export class UserCanService {
    constructor(private readonly loginService: LoginService) {}

    public userAble(permission: UserRight) {
        return this.loginService.hasRights(permission);
    }

    @getCached()
    get getAccsessToTerminalDashboard(): boolean {
        return this.userAble(UserRight.ViewTerminalDashboardPage);
    }

    @getCached()
    get getAccsessToTerminalVehicles(): boolean {
        return false; /// TODO temporary blocked because the module is not available yet
        return this.userAble(UserRight.ViewTerminalVehiclesPage);
    }

    @getCached()
    get getAccsessToTerminalStorage(): boolean {
        return false; /// TODO temporary blocked because the module is not available yet
        return this.userAble(UserRight.ViewTerminalStoragePage);
    }

    @getCached()
    get listActiveOperations(): boolean {
        return this.userAble(UserRight.ListOperationsActive);
    }
    @getCached()
    get listPendingOperations(): boolean {
        return this.userAble(UserRight.ListOperationsPending);
    }
    @getCached()
    get listCompletedOperations(): boolean {
        return this.userAble(UserRight.ListOperationsCompleted);
    }
    @getCached()
    get listDeclinedOperations(): boolean {
        return this.userAble(UserRight.ListOperationsDeclined);
    }

    @getCached()
    get listDeletedOperations(): boolean {
        return this.userAble(UserRight.ListOperationsDeleted);
    }

    @getCached()
    get canRejectOperation(): boolean {
        return this.userAble(UserRight.TerminalOperationReject)
    }

    @getCached()
    get addOperation(): boolean {
        return this.userAble(UserRight.TerminalOperationCreate);
    }
    @Cached()
    public editOperation(status: Status | undefined = undefined): boolean {
        switch (status) {
            case Status.Pending:
                return this.userAble(UserRight.TerminalOperationEditPending);
            case Status.Active:
                return this.userAble(UserRight.TerminalOperationEditActive);
            case Status.Completed:
                return false; /// TODO - blocked because the decision was made to protect completed tasks from changes
                return this.userAble(UserRight.TerminalOperationEditCompleted);
            default:
                break;
        }
        return false;
    }
    @Cached()
    public deleteOperation(status: Status | undefined = undefined): boolean {
        if(status === Status.Completed) { return false; }
        switch (status) {
            case Status.Pending:
                return this.userAble(UserRight.TerminalOperationDeletePending);
            case Status.Active:
                return this.userAble(UserRight.TerminalOperationDeleteActive);
            case Status.Declined:
                return this.userAble(UserRight.TerminalOperationDeleteDeclined);
            default:
                break;
        }
        return false;
    }
    @getCached()
    get completeOperation(): boolean {
        return this.userAble(UserRight.TerminalOperationComplete);
    }
    @getCached()
    get reactivateOperation(): boolean {
        return this.userAble(UserRight.TerminalOperationReactivate);
    }
    @getCached()
    get requestOperation(): boolean {
        return this.userAble(UserRight.TerminalOperationRequest);
    }
    @Cached()
    public acceptOperation(status: Status | undefined = undefined): boolean {
        switch (status) {
            case Status.Pending:
                return this.userAble(UserRight.TerminalOperationAccept);
            default:
                return false;
        }
        return false;
    }
    @Cached()
    public runOperationActions(status: Status | undefined = undefined): boolean {
        return this.acceptOperation(status)
            || this.editOperation(status)
            || this.copyOperation(status)
            || this.deleteOperation(status)
            || this.completeOperation;
    }
    @Cached()
    public updateOperationStatus(
        status: Status | undefined = undefined
    ): boolean {
        switch (status) {
            case Status.Active:
                return this.completeOperation;
            case Status.Completed:
                return this.reactivateOperation;
            default:
                break;
        }
        return false;
    }
    @Cached()
    public manageOperationResources(status: Status | undefined = undefined): boolean {
        return this.assignTheVehicles(status) || this.attachExtraFiles(status);
    }
    @Cached()
    public assignTheVehicles(status: Status | undefined = undefined): boolean {
        switch (status) {
            case Status.Pending:
                return this.userAble(UserRight.TerminalOperationAssignTheVehiclesPending);
            case Status.Active:
                return this.userAble(UserRight.TerminalOperationAssignTheVehiclesActive);
            case Status.Completed:
                return this.userAble(UserRight.TerminalOperationAssignTheVehiclesCompleted);
            default:
                break;
        }
        return false;
    }
    @Cached()
    public removeTheVehicles(status: Status | undefined = undefined): boolean {
        switch (status) {
            case Status.Pending:
                return this.userAble(UserRight.TerminalOperationRemoveTheVehiclesPending);
            case Status.Active:
                return this.userAble(UserRight.TerminalOperationRemoveTheVehiclesActive);
            case Status.Completed:
                return this.userAble(UserRight.TerminalOperationRemoveTheVehiclesCompleted);
            default:
                break;
        }
        return false;
    }
    @Cached()
    public attachExtraFiles(status: Status | undefined = undefined): boolean {
        switch (status) {
            case Status.Pending:
                return this.userAble(UserRight.TerminalOperationAttachExtraFilesPending);
            case Status.Active:
                return this.userAble(UserRight.TerminalOperationAttachExtraFilesActive);
            case Status.Completed:
                return this.userAble(UserRight.TerminalOperationAttachExtraFilesCompleted);
            default:
                break;
        }
        return false;
    }
    @Cached()
    public detachExtraFiles(status: Status | undefined = undefined): boolean {
        switch (status) {
            case Status.Pending:
                return this.userAble(UserRight.TerminalOperationDetachExtraFilesPending);
            case Status.Active:
                return this.userAble(UserRight.TerminalOperationDetachExtraFilesActive);
            case Status.Completed:
                return this.userAble(UserRight.TerminalOperationDetachExtraFilesCompleted);
            default:
                break;
        }
        return false;
    }
    @Cached()
    public reactivateCompleted(status: Status): boolean {
        return status == Status.Completed && this.reactivateOperation;
    }

    @Cached()
    public copyOperation(status: Status | undefined = undefined): boolean {
        switch (status) {
            case Status.Pending:
                return this.userAble(UserRight.TerminalOperationCopyPending);
            case Status.Active:
                return this.userAble(UserRight.TerminalOperationCopyActive);
            case Status.Completed:
                return this.userAble(UserRight.TerminalOperationCopyCompleted);
            case Status.Declined:
                return this.userAble(UserRight.TerminalOperationCopyDeclined);
            case Status.Deleted:
                return this.userAble(UserRight.TerminalOperationCopyDeleted);
            default:
                break;
        }
        return false;
    }
}
